export default __webpack_public_path__ + "static/media/song.b37fd619.png";